import React from 'react';
import { Field, FieldProps } from 'formik';
import classNames from 'classnames';

interface Props {
  name: string;
  value: string;
  text: string;
  disabled?: boolean;
  hidden?: boolean;
}

const FormRadio = (props: Props) => {
  const { name, text, value, disabled } = props;

  return (
    <Field name={name}>
      {({ field }: FieldProps) => {
        const RadioButtonClass = classNames({ 'radio-btn': true, disabled });
        const inputId = `${name}-${value}`;
        return (
          <div className="form__form-group">
            <div className="form__form-group-field" />
            <label className={`${RadioButtonClass}`} htmlFor={inputId}>
              <input
                {...field}
                id={inputId}
                className="radio-btn__radio"
                name={name}
                type="radio"
                value={value}
                checked={field.value === value}
                disabled={disabled}
              />
              <span className="radio-btn__radio-custom" />
              <span className="radio-btn__label">{text}</span>
            </label>
          </div>
        );
      }}
    </Field>
  );
};

export default FormRadio;
